import $ from 'jquery';

import {View} from 'backbone';

import _Template from 'designer/layout-toolbar-pane.ejs';
import Immutable from 'immutable';
import listService      from 'ListService.js';
import eventBus         from 'EventBus.js';
import util                 from 'util/Util';
import userService              from 'UserService';
import pageSyncService  from 'PageSyncService.js';
import constants        from 'Constants.js';

import groupAllTemplate from 'workflow/toolbox/toolbox-group-all.ejs';
import toolboxDesingerTemplate from 'workflow/toolbox/toolbox-groups.ejs';
import toolboxTabsTemplate from 'workflow/toolbox/toolbox-tabs.ejs';
import zoomService      from 'ZoomService.js'
import undoService      from 'UndoService.js';

import MobileMenuIcon  from '../../components/MobileWizard/MobileMenuIcon.js';

import leftPanelState   from "LeftPanelStateService";

class WorkflowToolbarPaneView extends View {


    initialize(opts) {
        this.options = opts || {};
        this.template = _Template;
        this.tagName = 'div';
        this.id = opts.el;


        this.events = {
            'click .layout-switch' : 'changeLayout',
            'click .control-tabs li a' : 'changeTabs',
            'click #behaviorView,#workflowView':'handleLinkNavigation',
            /* PF-3527 Commented as it will be used on next versions.
            'click #zoom-in': 'zoomIn',
            'click #zoom-out': 'zoomOut',
            'click #actual-size': 'actualSize',
            */

            'click #undoAction': 'undoAction',
            'click #redoAction': 'redoAction',
            'drop #toolSearch': 'avoidDragAndDrop',
            'click #workflowmain': 'workflowmain',
            'click #behaviors': 'behaviors'
        };

        this.templateMap = Immutable.Map([
            ['all', groupAllTemplate]
        ]);

        this.selectedGroupElement = 'all';
        //this.toolboxItems = toolboxItemMapService.getBehaviorItemsByGroup('all');
        this.model.set('helpUrl', constants.HELP_LAYOUT_TOOLBAR_URL);
        this.model.set('helpUrl2', constants.HELP_WORKFLOW_URL);
        
        //this.listenTo( eventBus, 'commonBehaviorGroupUpdated', this.commonGroupUpdated );
        return this;
    }

    workflowmain(ev){
        ev.preventDefault();
        leftPanelState.save();
        Backbone.history.loadUrl('workflowmain');
    }

    behaviors(ev){
        ev.preventDefault();
        leftPanelState.save();
        Backbone.history.loadUrl('behaviors');
    }

    handleLinkNavigation(){
        listService.itemSearched = 0;
        listService.linkClicked = true;
    }

    avoidDragAndDrop(){
        return false;
    }

    undoAction(){
        undoService.undo();
        eventBus.trigger('undoCacheEvent');
    }

    redoAction(){
        undoService.redo();
        eventBus.trigger('undoCacheEvent');
    }

    changeLayout(ev) {
        ev.preventDefault();
        leftPanelState.save();
        const target = ev.currentTarget;
        const layoutType = target.getAttribute('data-layout');
        listService.linkClicked = true;

        if (layoutType === 'deviceDesktop') {
            eventBus.trigger('gridSizeSet',util.isTrue(userService.userSettings.attributes._edShGrid));
            Backbone.history.loadUrl('edit');
        }

        if (listService.noPages){
            eventBus.trigger('hideCanvas');
        } else {
            eventBus.trigger('showCanvas');
        }
        /*
         formModel.set({
         currentDevice: layoutType
         })

         this.cleanUpLayoutSwitches();
         this.drawLayout(layoutType);
         $(target).addClass('active');

         eventBus.trigger('selectForm');
         */
    }

    cleanUpLayoutSwitches(){
        const layoutSwitches = this.$el.find('.layout-switch');
        layoutSwitches.map((index, item) => { $(item).removeClass('active') })
    }

    drawLayout(layoutType) {
        // Getting the current width either the one by default or the one assigned by the user via properties.
        let currentWidth=listService.currentForm.model.attributes.formWidth;
        let currentHeight=listService.currentForm.model.attributes.formHeight;

        const mapSizes = Immutable.Map([
            ['desktopLayout', {width:currentWidth , height: currentHeight}],
            ['tabletLayout', {width: constants.TABLET_MAX_WIDTH, height: constants.TABLET_MAX_HEIGHT}],
            ['phoneLayout', {width: constants.PHONE_MAX_WIDTH, height: constants.PHONE_MAX_HEIGHT}]
        ]);

        var newSize = mapSizes.get(layoutType);
        var newHeight = newSize.height;
        var newWidth = newSize.width;

        listService.currentForm.model.attributes.formHeight = newHeight;
        listService.currentForm.model.attributes.formWidth = newWidth;

        // Saving the current layout type inside the current model of the form.
        // This is perfomed to validate the bounda of the control in the PageSyncService.
        listService.currentForm.model.attributes.currentLayout = layoutType;
        eventBus.trigger('formWidthSet', newWidth);
        eventBus.trigger('formHeightSet', newHeight);
        var currPage = listService.currentPageId;
        listService.currentPageId = 0;
        pageSyncService.displayPage(currPage);

        listService.currentForm.model.trigger('change');
    }
    /* PF-3527 Commented as it will be used on next versions.
    zoomIn(evt) {
        evt.preventDefault();
        zoomService.handleCanvasZoom(constants.SCALE_FACTOR_ZOOM_IN);
        let canZoom=zoomService.handleAllControlsZoom(constants.SCALE_FACTOR_ZOOM_IN);
        if(canZoom){
            zoomService.fillZoomScaleAttribute(constants.SCALE_FACTOR_ZOOM_IN);
        }

    }

    zoomOut(evt) {
        evt.preventDefault();

        let canZoom=zoomService.handleAllControlsZoom(constants.SCALE_FACTOR_ZOOM_OUT);
        if(canZoom){
            zoomService.fillZoomScaleAttribute(constants.SCALE_FACTOR_ZOOM_OUT);
        }
        zoomService.handleCanvasZoom(constants.SCALE_FACTOR_ZOOM_OUT);
    }

    actualSize(evt) {
        evt.preventDefault();
        listService.currentForm.model.attributes.zoomScale=undefined;
        const layoutType = listService.currentForm.model.attributes.currentLayout;
        this.drawLayout(layoutType);
    }
    */
    changeTabs(ev) {
        ev.preventDefault();
        const buttonName = ev.currentTarget.id;
        const tabSectionName = ev.currentTarget.name;

        this.setSelectedGroup(tabSectionName);

    }

    setSelectedGroup(sectionName) {
        //this.selectedGroupElement = sectionName;

        //var items = toolboxItemMapService.getBehaviorItemsByGroup(sectionName);
        //this.model.set('items', items, {silent: true});

        // reset all tab panes
        $('#factories .tab-pane').empty();

        // insert template for selected group
        var gTemplate = this.templateMap.get(sectionName);
        $('#' + sectionName).html(gTemplate(this.model.toJSON()));

    }

    render() {
        this.$el.empty();
        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        $('ul.views-options a.layout-switch').removeClass('active');
        $('#workflowView a').addClass('active');

        $('#toolbox-tabs').html(toolboxTabsTemplate);
        $('#factories').html(toolboxDesingerTemplate);

        this.setSelectedGroup(this.selectedGroupElement);

        $(".layout-switch[data-layout='deviceTablet']").prop('disabled', 'disabled');
        $(".layout-switch[data-layout='devicePhone']").prop('disabled', 'disabled');
        $('#toolSearch').addClass('hide');

        this.delegateEvents();

        // Mobile forms wizard.
        MobileMenuIcon.render('mobileFormsView', { activeTab: listService.activeDashboardTab });
       
        return this;
    }
    
    remove() {
        this.undelegateEvents();
        this.stopListening();
        this.$el.empty();
        super.remove();
    }
}

export default WorkflowToolbarPaneView;
